import React, { useState, useEffect, useCallback } from 'react';
import { AlertTriangle, Bell, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from './config';

function AlarmPaneli({ user }) {
    const [alarmData, setAlarmData] = useState({ toplam: 0, gecikmis: 0, yaklasan: 0, esik_gun: 30 });
    const [loading, setLoading] = useState(false);

    const isMusteriOnly = user?.rol === 'Müşteri';

    const fetchAlarmlar = useCallback(async () => {
        setLoading(true);
        try {
            const firmaId = isMusteriOnly ? user.firma_id : 0;
            const res = await api.get('/api/alarmlar', { params: { firma_id: firmaId } });
            setAlarmData(res.data);
        } catch (err) {
            console.error('Alarm verisi alınamadı:', err);
        }
        setLoading(false);
    }, [isMusteriOnly, user?.firma_id]);

    useEffect(() => {
        fetchAlarmlar();
    }, [fetchAlarmlar]);

    return (
        <div style={panelStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Bell size={24} color="#f59e0b" />
                    Bakım Alarmları
                </h3>
                <Link to="/alarmlar" style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#3b82f6', textDecoration: 'none', fontSize: '14px' }}>
                    Tümünü Gör <ArrowRight size={16} />
                </Link>
            </div>

            {/* Özet Kartları */}
            <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ ...summaryCard, borderColor: '#ef4444' }}>
                    <span style={{ fontSize: '28px', fontWeight: 'bold', color: '#ef4444' }}>{alarmData.gecikmis}</span>
                    <span style={{ color: '#6b7280', fontSize: '13px' }}>Gecikmiş</span>
                </div>
                <div style={{ ...summaryCard, borderColor: '#f59e0b' }}>
                    <span style={{ fontSize: '28px', fontWeight: 'bold', color: '#f59e0b' }}>{alarmData.yaklasan}</span>
                    <span style={{ color: '#6b7280', fontSize: '13px' }}>Yaklaşan ({alarmData.esik_gun} gün)</span>
                </div>
                <div style={{ ...summaryCard, borderColor: '#10b981' }}>
                    <span style={{ fontSize: '28px', fontWeight: 'bold', color: '#10b981' }}>{alarmData.toplam}</span>
                    <span style={{ color: '#6b7280', fontSize: '13px' }}>Toplam</span>
                </div>
            </div>
        </div>
    );
}

const panelStyle = { backgroundColor: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const summaryCard = { flex: 1, padding: '15px', borderRadius: '10px', border: '2px solid', textAlign: 'center', display: 'flex', flexDirection: 'column' };

export default AlarmPaneli;
